export default __webpack_public_path__ + "static/media/real-talk.508aa405.svg";